import React from "react";
import Reporting from "../../components/Reporting";
import { APP_URLS } from "../../constants/urlConstants";
import { fetchFuelCustomers, generateReport } from "../../Redux/Actions/reporting";
import { EzToast, TOAST_SEVERITY } from "../../common/EzToast";
import { connect } from "react-redux";
import { ProgressBar } from "primereact/progressbar";
import Comingsoonpage from "../../common/Comingsoon";

const ReportingScreen = (props) => {
  const {
    generateReport,
    isLoading,
    toastMessage,
    toastSeverity,
    isGenerateReportSuccess,
    isGenerateReportError,
    screenPermissions,
    customers,
    fetchFuelCustomers,
  } = props;

  const getToastProps = () => {
    if (toastMessage) {
      return {
        severity: toastSeverity,
        toastTitle: toastMessage,
        shouldShowToast: true,
      };
    }
    return {};
  };

  const reportingProps = {
    generateReport,
    screenPermissions,
    isGenerateReportSuccess,
    customers,
    fetchFuelCustomers,
  };

  const renderProgressBar = () => {
    return <ProgressBar mode="indeterminate" style={{ height: "6px" }} />;
  };

  return (
    <>
      {isLoading && renderProgressBar()}
      <EzToast {...getToastProps()} />
      <Reporting {...reportingProps} />
    </>
  );
};

const mapDispatchToProps = (dispatch) => {
  return {
    generateReport: (payload) => dispatch(generateReport(payload)),
    fetchFuelCustomers: (payload) => dispatch(fetchFuelCustomers(payload)),
  };
};

const mapStateToProps = (state, ownProps) => {
  return {
    ...ownProps,
    isLoading: selectFromReportReducer(state, "isLoading"),
    customers: selectFromReportReducer(state, "customers"),
    isGenerateReportError: selectFromReportReducer(
      state,
      "isGenerateReportError"
    ),
    isGenerateReportSuccess: selectFromReportReducer(
      state,
      "isGenerateReportSuccess"
    ),
    toastMessage: selectFromReportReducer(state, "toastMessage"),
    toastSeverity: selectFromReportReducer(state, "toastSeverity"),
  };
};

const selectFromReportReducer = (state, path) => {
  return selectReportReducer(state)[path];
};

const selectReportReducer = ({ reportReducer }) => {
  return reportReducer;
};
export default connect(mapStateToProps, mapDispatchToProps)(ReportingScreen);
